import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import FAQAccordionUI from 'components/consumer/user-orders-build-updates/FAQAccordion/FAQAccordionUI';
import Link from 'components/consumer/Link';

const FAQs = ({ steps }) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  return (
    <>
      <div className="text-sm">
        Have another question? Please visit our{' '}
        <Link
          to="/contact-us/"
          className="text-brand !no-underline hover:!no-underline"
        >
          Contact Us
        </Link>
        .
      </div>
      <div className="mx-0 my-6 [border-top:1px_solid_#e5e5e5]" />
      {steps.length > 0 &&
        steps.map((step, idx) => (
          <FAQAccordionUI
            key={step.question}
            title={step.question}
            content={step.answer}
            isActive={idx === activeIndex}
            toggleAccordion={() => {
              setActiveIndex(idx === activeIndex ? -1 : idx);
            }}
          />
        ))}
    </>
  );
};

FAQs.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
};

const FAQCommonQuestionsUI = ({ steps }) => {
  const { isMobile } = useScreen();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-lg md:px-10 md:py-12 md:bg-gray-light9">
      {isMobile ? (
        <FAQAccordionUI
          title="Common questions"
          content={<FAQs steps={steps} />}
          isActive={isOpen}
          hasInnerAccordion
          toggleAccordion={() => {
            setIsOpen(!isOpen);
          }}
        />
      ) : (
        <>
          <div className="text-lg font-bold text-gray">Common questions</div>
          <FAQs steps={steps} />
        </>
      )}
    </div>
  );
};

FAQCommonQuestionsUI.propTypes = FAQs.propTypes;

export default FAQCommonQuestionsUI;
